"use strict";
/**
 * Special Collaborator Constants
 *
 * Codes for collaborators that have special shift validation rules.
 * Replaces hardcoded "MAT" / "RGL" strings in frontend helpers.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPERVISED_COLLABORATOR_CODES = void 0;
/**
 * Collaborator codes that are exempt from certain shift coverage rules
 * (e.g., they may work supervised shifts without full vet coverage).
 */
exports.SUPERVISED_COLLABORATOR_CODES = ["MAT", "RGL"];
